var Accessibilities = {
  COMMON: -1,
  CLIENT_ONLY: 0,
  ADMIN_AND_SALES_REP: 1,
  ADMIN_ONLY: 2,
  ADMIN_AND_SALES_REP_AND_PRESCRIBER: 3,
};

module.exports = Accessibilities;
